var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-table-item-wrap"},[_vm._v(" "+_vm._s(_vm._.isNil(_vm.value) || _vm.value === '' ? _vm.defaultValue : _vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }